import React from 'react';
import { connect } from 'react-redux';

import get from 'lodash.get';

import ShareButtons from '../common/shareButtons';

import './index.css';

export class ShareButtonContainer extends React.Component {
    getDefaultShareText = () => {
        if (this.props.defaultShareText) {
            return this.props.defaultShareText
                .replace(/{CampaignName}/g, this.props.campaignName)
                .replace(/{OrganizationName}/g, this.props.organizationName);
        }
        return "";
    }

    render() {
        const { shareUrl } = this.props;

        return (
            <div className="share-cont">
                <span>{this.props.shareText || 'Share page'}</span>
                <ShareButtons.FacebookShare url={shareUrl} />
                <ShareButtons.TwitterShare url={shareUrl} defaultShareText={this.getDefaultShareText()} />
                <ShareButtons.LinkedInShare url={shareUrl} />
            </div>

        );
    }
}

const mapState = ({ page }) => {
    return {
        campaignName: get(page, 'campaign.name'),
        organizationName: get(page, 'organization.name'),
        defaultShareText: get(page, 'campaign.template.value.customText.socialNetworksMetadata.campaign.defaultMessage')
    }
}

const ShareButton = connect(mapState)(ShareButtonContainer);
export default ShareButton;